import { render, staticRenderFns } from "./ForecastMB.vue?vue&type=template&id=2d3fd298"
import script from "./ForecastMB.vue?vue&type=script&lang=js"
export * from "./ForecastMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports